import './RequestedProperties.css';
import React, { useState, useEffect, useRef, useCallback } from "react";
import PropertiesService from "../../Services/PropertiesService";
import moment from 'moment';
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import "react-circular-progressbar/dist/styles.css";
import UserImage from "../../Assets/Images/ChatBot/user.png";


// import {
//   FaMapMarkerAlt,
//   FaPhone,
//   FaEnvelope,
//   FaFilePdf,
//   FaCheckCircle,
// } from "react-icons/fa";

import ProgressWithCategories from "../ProgressWithCategories/ProgressWithCategories";
import {
  ArrowLeft,
  MapPinHouseIcon,
  Menu,
  Search,
  Building2,
  MessageSquareOff,
  FileText,
  CheckCircle2,
  Clock,
  AlertCircle,
  X,
  Send,
  ShieldCheck,
  Info,
  ChevronLeft,
  ChevronRight,
  Pencil
} from 'lucide-react';
import EditPropertyModal from '../EditPropertyModel/EditPropertyModel';
import { server } from '../../ServerUrl';
const RequestedProperties = () => {
  const [ShowPropertyList, setShowPropertyList] = useState(false);
  const [ShowRightPanel, setShowRightPanel] = useState(false);
  const socket = useRef(null);
  const [Footerdisable, setFooterdisable] = useState(false);
  const [AllUsers, setAllUsers] = useState([]);
  const [AllCivilEngineers, setAllCivilEngineers] = useState([]);
  const [showAllQuestions, setShowAllQuestions] = useState(false);
  const toggleShowAllQuestions = () => {
    setShowAllQuestions(prev => !prev);
  };
  const [, setRejected] = useState(false);
  const [showAllFiles, setShowAllFiles] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 640;
      setIsMobile(mobile);
      if (!mobile) {
        setShowPropertyList(true);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const toggleShowAllFiles = () => {
    setShowAllFiles((prev) => !prev);
  };
  const messagesEndRefUser2 = useRef(null);
  const [chartId, setChartId] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [Properties, setProperties] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [, setAlertMessage] = useState([]);
  const [UserUploadedDocs, setUserUploadedDocs] = useState([]);
  const [, setIsLoading] = useState(false);
  const [, setHasError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [PropertyDetails, setPropertyDetails] = useState({});
  const [page, setPage] = useState("page1");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [, setvalueData] = useState(null)
  const [perDocState, setPerDocState] = useState({});
  const [SelectedMessageData, setSelectedMessageData] = useState('')
  // eslint-disable-next-line no-unused-vars -- setBlockChat reserved for getSingleEngineer when wired
  const [BlockChat, setBlockChat] = useState('')
  const [loading, setLoading] = useState(false);
  const [isUserClick, setIsUserClick] = useState(false);
  const [buttonLoading, setButtonLoading] = useState({
    send: false,
    saleDeedRequest: false,
    registrationRequest: false,
    acceptId: null,
    rejectSubmit: false,
  });
  const SALE_DEED_REQUEST_TEXT = "To complete the process, upload the sale deed draft";
  const REGISTRATION_REQUEST_TEXT =
    "To complete the process, upload the registration document";

  const getDaysLeftForSort = (dateValue) => {
    if (!dateValue) return Number.MAX_SAFE_INTEGER;

    const today = new Date();
    const deadline = new Date(dateValue);
    const timeDiff = deadline - today;
    const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

    return daysRemaining >= 0 ? daysRemaining : 0;
  };

  const getPropertyPriorityRank = (property) => {
    const messageCount = Number(property?.messageCount) || 0;
    if (messageCount > 0) return 1;

    const hasSaleDeedDeadline =
      property?.saleDeedSubmissionDate &&
      property?.assignedCivilEngineer &&
      property?.saleDeedUploaded === "";

    if (hasSaleDeedDeadline) {
      const daysLeft = getDaysLeftForSort(property?.saleDeedSubmissionDate);
      if (daysLeft === 0) return 2;
      return 3;
    }

    return 4;
  };

  const sortPropertiesByPriority = (list = []) => {
    return [...list].sort((a, b) => {
      const aRank = getPropertyPriorityRank(a);
      const bRank = getPropertyPriorityRank(b);
      if (aRank !== bRank) return aRank - bRank;

      const aMessageCount = Number(a?.messageCount) || 0;
      const bMessageCount = Number(b?.messageCount) || 0;
      if (aMessageCount !== bMessageCount) return bMessageCount - aMessageCount;

      const aDaysLeft = getDaysLeftForSort(a?.saleDeedSubmissionDate);
      const bDaysLeft = getDaysLeftForSort(b?.saleDeedSubmissionDate);
      if (aDaysLeft !== bDaysLeft) return aDaysLeft - bDaysLeft;

      const aUpdatedAt = new Date(a?.updatedAt || a?.createdAt || 0).getTime();
      const bUpdatedAt = new Date(b?.updatedAt || b?.createdAt || 0).getTime();
      if (aUpdatedAt !== bUpdatedAt) return bUpdatedAt - aUpdatedAt;

      return (a?.address || "").localeCompare(b?.address || "");
    });
  };

  // eslint-disable-next-line no-unused-vars
  const onLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };
  // eslint-disable-next-line no-unused-vars
  const onError = () => {
    setIsLoading(false);
    setHasError(true);
  };
  useEffect(() => {
    // If we have a selected user but they are no longer in the assigned properties list
    if (selectedUser && filteredProperties.length > 0) {
      const isStillAssigned = filteredProperties.some(p => p._id === selectedUser._id);

      if (!isStillAssigned) {
        setSelectedUser(null);
        setMessages([]);
        setUserUploadedDocs([]);
        localStorage.removeItem("selectedPropertyId");
      }
    } else if (filteredProperties.length === 0 && selectedUser) {
      // If the list is empty entirely
      setSelectedUser(null);
      setMessages([]);
      localStorage.removeItem("selectedPropertyId");
    }
  }, [filteredProperties, selectedUser]);
  useEffect(() => {
    getAllUsers()
    getAllCivilEngs()
    const userDetailsFromLocalStorage = JSON.parse(
      localStorage.getItem("userDetails")
    );
    setUserDetails(userDetailsFromLocalStorage);
    getAssignedProperties(userDetailsFromLocalStorage?.civilEng_id);
    socket.current = io(server, {
      transports: ["websocket"],
      // only if using self-signed certs (not recommended for production)
    });

    socket.current.on('connect', () => {
      const userId = userDetailsFromLocalStorage.civilEng_id;
      socket.current.emit('addNewUser', userId);
      socket.current.on('getOnlineUsers', (res) => {
      })
    })
    if (
      userDetailsFromLocalStorage &&
      userDetailsFromLocalStorage?.civilEng_id
    ) {
      socket.current.emit(
        "addNewUser",
        userDetailsFromLocalStorage?.civilEng_id
      );
    }
    socket.current.on("getOnlineUsers", function (data) {
    });
    socket.current.on("receiveMessage", async (incomingMessage) => {
      console.log(incomingMessage, 'incomingMessage');

      const senderId = incomingMessage.senderId;
      const receiverId = incomingMessage.receiverId;

      const { data: getDocsResponse } = await PropertiesService.getDocs({ userId: senderId });
      const registrationDocs = getDocsResponse?.data?.filter(doc => doc.Type === 'Registration Document');

      console.log(getDocsResponse, 'Fetched Docs from Sender');

      if (registrationDocs?.length > 0) {
        await getAssignedProperties(receiverId);

        const { data: propertyRes } = await PropertiesService.getSignleProperty({ propertyId: senderId });
        const propertyData = propertyRes?.data;

        console.log(propertyData, 'Fetched Sender Property');
        if (registrationDocs?.length > 0) {
          await getAssignedProperties(receiverId);
          if (propertyData) {
            setSelectedUser(null);
            setMessages([]);
            setUserUploadedDocs([]);
            console.log('Chat cleared because property updated/unassigned');
          }
        }
        if (propertyData) {
          setSelectedUser("")
          console.log('working1')
          // handleOnClickUser(propertyData);

          setMessages([]);
        }
      } else if (selectedUser?._id === senderId) {
        console.log('Appending message to current chat');
        setMessages(prev => [...prev, incomingMessage]);
      } else {
        console.log('Appending message to last  chat');
        const { data: propertyRes } = await PropertiesService.getSignleProperty({ propertyId: senderId });
        const propertyData = propertyRes?.data;
        console.log(propertyData, 'propertyData')
        if (!propertyData) return;

        const updatedMessageCount = (propertyData.messageCount || 0) + 1;

        const updatePayload = {
          propertyId: propertyData._id,
          userId: propertyData.userId,
          messageCount: updatedMessageCount,
        };

        await PropertiesService.updateProperty(updatePayload);
        if (incomingMessage.text === 'Hi Engineer, I have uploaded all the documents. Can you help me with the further process?') {
          await getAssignedProperties(receiverId);

          const { data: propertyRes } = await PropertiesService.getSignleProperty({ propertyId: senderId });
          const propertyData = propertyRes?.data;

          console.log(propertyData, 'Fetched Sender Property');

          if (propertyData) {
            console.log('working2')
            handleOnClickUser(propertyData);
          }
        }
        setFilteredProperties((prev) => {
          let updated = prev.map((property) =>
            property._id === propertyData._id
              ? { ...property, messageCount: updatedMessageCount }
              : property
          );
          return sortPropertiesByPriority(updated);
        });
      }
    });
    return () => {
      socket.current.off("receiveMessage");
      socket.current.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- socket effect scoped to chartId
  }, [chartId]);
  const [, setDocsStatus] = useState({});
  const getUserUploadedDocuments = async (x) => {
    const obj = { userId: x._id };
    const response = await PropertiesService.getDocs(obj);
    return response?.data?.data?.length > 0;
  };
  useEffect(() => {
    const checkAllDocs = async () => {
      const statusMap = {};
      await Promise.all(
        filteredProperties.map(async (property) => {
          const hasDocs = await getUserUploadedDocuments(property);
          statusMap[property._id] = hasDocs;
        })
      );
      setDocsStatus(statusMap);
    };
    checkAllDocs();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when filteredProperties changes
  }, [filteredProperties]);
  const getAssignedProperties = useCallback(async (id) => {
    let obj = { engineerId: id };
    const response = await PropertiesService.getCivilEngineerProperties(obj);

    if (response?.data?.message === "Success") {
      const newProperties = response?.data?.data || [];
      const sortedProperties = sortPropertiesByPriority(newProperties);
      setProperties(sortedProperties);
      console.log("sortedProperties_sortedProperties", sortedProperties)
      setFilteredProperties(sortedProperties.reverse());
      const currentId = localStorage.getItem("selectedPropertyId");
      if (currentId && !sortedProperties.find(p => p._id === currentId)) {
        setSelectedUser(null);
        setMessages([]);
        localStorage.removeItem("selectedPropertyId");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sort helper is stable for this component lifecycle
  }, []);

  useEffect(() => {
    const userDetailsFromLocalStorage = JSON.parse(
      localStorage.getItem("userDetails")
    );
    setUserDetails(userDetailsFromLocalStorage);

    getAssignedProperties(userDetailsFromLocalStorage?.civilEng_id);;
    const handleFocus = () => getAssignedProperties(userDetailsFromLocalStorage?.civilEng_id);;
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount and on focus
  }, [getAssignedProperties]);
  const handleOnClickUser = async (property) => {
    setMessages([]);
    setUserUploadedDocs([]);
    setIsUserClick(true);

    localStorage.setItem("selectedPropertyId", property._id);

    let obj = {
      propertyId: property?._id,
      userId: property?.userId,
      messageCount: 0,
    };

    await PropertiesService.updateProperty(obj);

    if (isMobile) {
      setShowPropertyList(false);
    }

    setSelectedUser(property);
    setAlertMessage("");
    getQuestion(property);
    findUser(property);
  };
  useEffect(() => {
    const savedPropertyId = localStorage.getItem("selectedPropertyId");

    if (!savedPropertyId || filteredProperties.length === 0) return;

    const foundProperty = filteredProperties.find(
      (p) => p._id === savedPropertyId
    );

    if (foundProperty) {
      if (selectedUser?._id === foundProperty._id) {
        setSelectedUser(foundProperty);
        return;
      }

      setSelectedUser(foundProperty);
      getQuestion(foundProperty);
      findUser(foundProperty);

      if (isMobile) {
        setShowPropertyList(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- findUser, isMobile intentionally excluded
  }, [filteredProperties, selectedUser?._id]);


  const getQuestion = async (property) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    setUserDetails(userDetails);
    const response = await PropertiesService.getQuestions();
    if (response?.data?.message === "Success") {
      let obj = {
        userId: property?._id,
      };

      const response2 = await PropertiesService.getDocs(obj);

      if (response2?.data?.message === "Success") {
        const filterData = response2.data.data;
        const filteredDocuments = filterData.filter((question) => {
          return response?.data?.data.some(
            (filterItem) => filterItem.question === question.Type
          );
        });
        if (filteredDocuments.length > 0) {
          setUserUploadedDocs(filteredDocuments);
        } else {
          setUserUploadedDocs([]);
        }
      }
    } else {
      toast.error(
        "Error in fetching the questions. Try again by reloading the page"
      );
    }
  };
  const findUser = async (property) => {
    if (!userDetails?.civilEng_id || !property?._id) {
      console.error(
        "Invalid user or property ID:",
        userDetails?.civilEng_id,
        property?._id
      );
      return;
    }

    setLoading(true); // 2. Start loading

    let obj2 = { firstId: userDetails?.civilEng_id, secondId: property?._id };

    try {
      const findChat = await PropertiesService.findChat(obj2);
      console.log(findChat, 'findChat')
      if (
        findChat?.data?.message === "Success" &&
        findChat?.data?.data?.length > 0
      ) {
        const chat = findChat?.data?.data[0];

        setChartId(chat?._id);

        let response = await PropertiesService.getMessagesWithChatId({
          chartId: chat?._id,
        });
        if (!response?.data?.data || response?.data?.data?.length === 0) {
          response = await PropertiesService.getMessages({
            userId: property?._id,
          });
        }
        console.log(response, 'responseddd')
        if (response?.data?.message === "Success") {
          setMessages(response?.data?.data || []);

          let foundUploadPrompt = (response?.data?.data || []).some(
            (msg) => msg.text === "To complete the process, upload the sale deed draft"
          );

          setFooterdisable(foundUploadPrompt);
        } else {
          setMessages([]);
        }
      } else {
        setChartId(null);
        setMessages([]);
      }
    } catch (error) {
      console.error("Error while finding chat:", error);
    } finally {
      setLoading(false); // 3. Stop loading
    }
  };
  const getOrCreateChatId = async (property = selectedUser) => {
    const engineerId = userDetails?.civilEng_id;
    const propertyId = property?._id;

    if (!engineerId || !propertyId) {
      return null;
    }

    if (chartId) {
      return chartId;
    }

    const existingChatResponse = await PropertiesService.findChat({
      firstId: engineerId,
      secondId: propertyId,
    });

    if (
      existingChatResponse?.data?.message === "Success" &&
      existingChatResponse?.data?.data?.length > 0
    ) {
      const existingChatId = existingChatResponse.data.data[0]?._id;
      setChartId(existingChatId);
      return existingChatId;
    }

    const createdChatResponse = await PropertiesService.createChat({
      firstId: engineerId,
      secondId: propertyId,
    });

    if (createdChatResponse?.data?.message === "Success") {
      const createdChatId =
        createdChatResponse?.data?.data?._id ||
        createdChatResponse?.data?.data?.chat?._id;

      if (createdChatId) {
        setChartId(createdChatId);
        return createdChatId;
      }
    }

    return null;
  };
  const handleSendMessage = async () => {
    if ((message.trim() || uploadedFile) && !buttonLoading.send) {
      setButtonLoading((prev) => ({ ...prev, send: true }));
      try {
        const activeChatId = await getOrCreateChatId();

        if (!activeChatId) {
          toast.error("Unable to start chat. Please try again.");
          return;
        }

        const msgData = {
          senderId: userDetails.civilEng_id,
          receiverId: selectedUser?._id,
          text: message,
          chartId: activeChatId,
          id: Date.now(),
          fileUrl: uploadedFile ? [uploadedFile] : [],
        };

        socket.current.emit("sendMessage", msgData);

        const obj = {
          chartId: activeChatId,
          senderId: msgData.senderId,
          text: msgData.text,
          files: msgData.fileUrl,
        };

        const createdMessage = await PropertiesService.createMessage(obj);
        if (createdMessage.data.message === "Success") {
          setMessages((prevMessages) => [
            ...prevMessages,
            createdMessage.data.data,
          ]);
        } else {
          socket.current.emit("addNewUser", userDetails.civilEng_id);
          const response = await PropertiesService.getMessagesWithChatId({
            chartId: activeChatId,
          });
          if (response.data.message === "Success") {
            setMessages(response.data.data);
          }
        }
      } catch (error) {
        console.error("Error sending message:", error);
      } finally {
        setButtonLoading((prev) => ({ ...prev, send: false }));
      }

      setMessage("");
      setUploadedFile(null);
    }
  };

  useEffect(() => {
    if (messagesEndRefUser2.current) {
      messagesEndRefUser2.current.scrollIntoView({
        behavior: isUserClick ? "auto" : "instant",
        block: "end"
      });
      setIsUserClick(false); // reset
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- isUserClick intentionally excluded to avoid scroll loop
  }, [messages]);
  const handleEditIconClick = (user) => {
    setPropertyDetails(user);
    console.log(user, 'user')
    setShowEditModal(true);
    setPage("page1");
  };
  const handleSendSaledeedRequestToUser = async (response) => {
    if (response === 'saledeed') {
      if (Footerdisable === false && !buttonLoading.saleDeedRequest) {
        setButtonLoading((prev) => ({ ...prev, saleDeedRequest: true }));
        const msgData = {
          senderId: userDetails?.civilEng_id,
          receiverId: selectedUser?._id,
          text: SALE_DEED_REQUEST_TEXT,
          chartId: chartId,
          id: Date.now(),
          fileUrl: uploadedFile ? [uploadedFile] : [],
        };

        socket.current.emit("sendMessage", msgData);
        const obj = {
          chartId: chartId,
          senderId: msgData.senderId,
          text: msgData.text,
          files: msgData.fileUrl,
        };
        try {
          const createdMessage = await PropertiesService.createMessage(obj);
          if (createdMessage.data.message === "Success") {
            setMessages((prevMessages) => [
              ...prevMessages,
              createdMessage.data.data,
            ]);
            setFooterdisable(true)
          } else {
            socket.current.emit("addNewUser", userDetails.civilEng_id);
            const response = await PropertiesService.getMessagesWithChatId({
              chartId: chartId,
            });
            if (response.data.message === "Success") {
              setMessages(response.data.data);
            }
          }
        } catch (error) {
          console.error("Error sending message:", error);
        } finally {
          setButtonLoading((prev) => ({ ...prev, saleDeedRequest: false }));
        }

        setMessage("");
        setUploadedFile(null);
      }
    } else {
      if (Footerdisable === false && !buttonLoading.registrationRequest) {
        setButtonLoading((prev) => ({ ...prev, registrationRequest: true }));
        const msgData = {
          senderId: userDetails?.civilEng_id,
          receiverId: selectedUser?._id,
          text: REGISTRATION_REQUEST_TEXT,
          chartId: chartId,
          id: Date.now(),
          fileUrl: uploadedFile ? [uploadedFile] : [],
        };

        socket.current.emit("sendMessage", msgData);
        const obj = {
          chartId: chartId,
          senderId: msgData.senderId,
          text: msgData.text,
          files: msgData.fileUrl,
        };
        try {
          const createdMessage = await PropertiesService.createMessage(obj);
          if (createdMessage.data.message === "Success") {
            setMessages((prevMessages) => [
              ...prevMessages,
              createdMessage.data.data,
            ]);
            setFooterdisable(true)
          } else {
            socket.current.emit("addNewUser", userDetails.civilEng_id);
            const response = await PropertiesService.getMessagesWithChatId({
              chartId: chartId,
            });
            if (response.data.message === "Success") {
              setMessages(response.data.data);
            }
          }
        } catch (error) {
          console.error("Error sending message:", error);
        } finally {
          setButtonLoading((prev) => ({ ...prev, registrationRequest: false }));
        }

        setMessage("");
        setUploadedFile(null);
      }
    }

  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = Properties.filter(item =>
      item.address?.toLowerCase().includes(value.toLowerCase()) ||
      item.property_Key?.toLowerCase().includes(value.toLowerCase()) ||
      item.pincode?.toLowerCase().includes(value.toLowerCase()) ||
      item.region?.toLowerCase().includes(value.toLowerCase()) ||
      item.city?.toLowerCase().includes(value.toLowerCase()) ||
      item.state?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredProperties(sortPropertiesByPriority(filtered));
  };
  const getRemainingDays = (property) => {
    if (!property) return null;

    const today = new Date();
    const deadline = new Date(property.saleDeedSubmissionDate);
    const timeDiff = deadline - today;

    const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    return daysRemaining >= 0 ? daysRemaining : 0;
  };
  const getAllUsers = async () => {
    const response = await PropertiesService.getdoCityUsers()
    setAllUsers(response?.data?.data)
  }
  const getAllCivilEngs = async () => {
    const response = await PropertiesService.getAllCivilEngs()
    setAllCivilEngineers(response?.data?.data)
  }
  const DEFAULT_DUMMY_AVATAR = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100'><circle cx='12' cy='12' r='12' fill='%23cbd5e1'/><path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' fill='%2394a3b8'/></svg>";

  const getUserImage = (propertyId) => {
    if (!propertyId) return DEFAULT_DUMMY_AVATAR;

    const targetUserId = typeof propertyId === 'object' ? (propertyId?.userId || propertyId?._id || propertyId?.user_id) : propertyId;
    const filterUser = AllUsers?.find((x) => x.user_id === targetUserId || x._id === targetUserId);

    if (filterUser?.image && typeof filterUser.image === 'string' && filterUser.image.trim() !== "" && filterUser.image !== "null" && filterUser.image !== "undefined") {
      return filterUser.image;
    }

    const engId = typeof propertyId === 'object' ? (propertyId?.assignedCivilEngineer || propertyId?.civilEng_id || propertyId?._id) : propertyId;
    const filterEng = AllCivilEngineers?.find((x) => x.civilEng_id === engId || x._id === engId);

    if (filterEng?.image && typeof filterEng.image === 'string' && filterEng.image.trim() !== "" && filterEng.image !== "null" && filterEng.image !== "undefined") {
      return filterEng.image;
    }

    if (UserImage && typeof UserImage === 'string' && UserImage.trim() !== '' && !UserImage.includes('undefined')) {
      return UserImage;
    }

    return DEFAULT_DUMMY_AVATAR;
  };
  const getUserName = (propertyId) => {
    const filterTheUser = AllUsers?.filter((x) => x.user_id === propertyId?.userId);

    if (filterTheUser?.length > 0 && filterTheUser[0]?.name) {
      return filterTheUser[0].name;
    } else {
      const filterTheUser = AllCivilEngineers?.filter((x) => x.civilEng_id === propertyId);
      if (filterTheUser?.length > 0 && filterTheUser[0]?.name) {
        return filterTheUser[0].name;
      } else {
        return 'John';
      }
    }
  };
  const checkUserUploadedToQuestions = (datas) => {
    const filterdata = UserUploadedDocs.find((x) => x.Type === datas.Type);
    return filterdata && filterdata.url !== "No";
  };
  const showPropertyListView = () => {
    setShowPropertyList(true);
  };
  const handleReject = (msg) => {
    setPerDocState(prev => ({
      ...prev,
      [msg._id]: { rejected: true, reason: "" }
    }));
    setMessages(prev =>
      prev.map(m =>
        m._id === msg._id ? { ...m, verificationStatus: "Pending" } : m
      )
    );
    console.log(msg, 'msg')
    setSelectedMessageData(msg);
  };
  const handleReasonChange = (msg, value) => {
    setPerDocState(prev => ({
      ...prev,
      [msg._id]: {
        ...(prev[msg._id] || {}),
        reason: value
      }
    }));
  };
  const submitReason = async () => {
    if (buttonLoading.rejectSubmit) return;
    const reason = perDocState[SelectedMessageData._id]?.reason || "";
    if (!reason.trim()) return;
    setButtonLoading((prev) => ({ ...prev, rejectSubmit: true }));
    setMessages(prev =>
      prev.map(m =>
        m._id === SelectedMessageData._id ? { ...m, verificationStatus: "Rejected" } : m
      )
    );

    setPerDocState(prev => ({
      ...prev,
      [SelectedMessageData._id]: { rejected: false, reason: "" }
    }));
    try {

      const findMessage = await PropertiesService.getMessages({ userId: selectedUser?._id });
      console.log(findMessage, 'findMessage');
      if (findMessage?.data?.data?.length > 0) {
        const updatedMessageIds = [];
        for (let message of findMessage.data.data) {
          if (message.verificationStatus === 'Pending') {
            const messageResponse = await PropertiesService.updateMessage({
              messageId: message._id,
              verificationStatus: "Rejected",
              rejectionReason: reason
            });
            if (messageResponse?.data?.data?._id) {
              updatedMessageIds.push(messageResponse.data.data._id);
            }
          }
        }
        if (updatedMessageIds.length > 0) {
          setMessages(prev =>
            prev.map(m =>
              updatedMessageIds.includes(m._id)
                ? { ...m, verificationStatus: "Rejected" }
                : m
            )
          );
        }
      }
      const msgData = {
        senderId: userDetails.civilEng_id,
        receiverId: selectedUser?._id,
        text: 'Saledeed Rejected',
        chartId: chartId,
        id: Date.now(),
        fileUrl: [],
        rejected: true,
        reason: reason
      };
      socket.current.emit("sendMessage", msgData);
      const createdMessage = await PropertiesService.createMessage({
        chartId: chartId,
        senderId: msgData.senderId,
        text: 'Saledeed Rejected',
        files: msgData.fileUrl,
      });

      if (createdMessage.data.message === "Success") {
        setMessages(prev => [...prev, createdMessage.data.data]);
        const findDocument = await PropertiesService.getDocs({ userId: selectedUser?._id });
        if (findDocument?.data?.data?.length > 0) {
          for (let x of findDocument?.data?.data) {
            if (x.Type === 'saledeedDocument' && x.verificationStatus === 'Pending') {
              console.log('working')
              const ipdated = await PropertiesService.UpdateDocument({
                userId: x.userId,
                fields: x.fields,
                docId: x.docId,
                newDocUrl: x.newDocUrl,
                verificationStatus: "Rejected",
                rejectionReason: reason
              });
              console.log(ipdated, 'ipdated')
            }
          }
        }
      }
    } catch (err) {
      console.error("Error rejecting:", err);
    } finally {
      setButtonLoading((prev) => ({ ...prev, rejectSubmit: false }));
    }
  };
  const handleAccepty = async (x) => {
    if (buttonLoading.acceptId) return;
    setButtonLoading((prev) => ({ ...prev, acceptId: x?._id || 'loading' }));
    const findDocument = await PropertiesService.getDocs({ userId: selectedUser?._id });
    console.log(findDocument, 'findDocument')
    if (findDocument?.data?.data?.length > 0) {
      for (let doc of findDocument?.data?.data) {
        if (doc.Type === 'saledeedDocument') {
          const updatedDoc = await PropertiesService.UpdateDocument({
            docId: doc.docId,
            newDocUrl: doc.docUrl,
            verificationStatus: "Accepted",
            rejectionReason: ''
          });
          console.log(updatedDoc, '')
        }
      }
    }
    const findMessage = await PropertiesService.getMessages({ userId: selectedUser?._id });

    if (findMessage?.data?.data?.length > 0) {
      const updatedMessageIds = [];
      for (let message of findMessage.data.data) {
        if (message.verificationStatus === 'Pending') {
          const messageResponse = await PropertiesService.updateMessage({
            messageId: message._id,
            verificationStatus: "Accepted",
            rejectionReason: ''
          });
          if (messageResponse?.data?.data?._id) {
            updatedMessageIds.push(messageResponse.data.data._id);
          }
        }
      }
      if (updatedMessageIds.length > 0) {
        const findMessage = await PropertiesService.getMessages({ userId: selectedUser?._id });
        console.log('setMessages');
        setMessages(findMessage?.data?.data);
      }
    }
    try {
      const msgData = {
        senderId: userDetails.civilEng_id,
        receiverId: selectedUser?._id,
        text: "🎉🎊 Congratulations! Sale Deed Draft Accepted Successfully 🎉🎊",
        chartId: chartId,
        id: Date.now(),
        fileUrl: [],

      };

      let obj33 = {
        propertyId: selectedUser?._id,
        userId: selectedUser?.userId,
        saledeedVerified: true,
      };

      await PropertiesService.updateProperty(obj33);

      socket.current.emit("sendMessage", msgData);

      const obj = {
        chartId: chartId,
        senderId: msgData.senderId,
        text: msgData.text,
        files: msgData.fileUrl,
        verificationStatus: 'Accepted'
      };

      const createdMessage = await PropertiesService.createMessage(obj);
      if (createdMessage.data.message === "Success") {
        setMessages(prevMessages => [
          ...prevMessages,
          createdMessage.data.data,
        ]);
      } else {
        socket.current.emit("addNewUser", userDetails.civilEng_id);
        const response = await PropertiesService.getMessagesWithChatId({ chartId });
        if (response.data.message === "Success") {
          setMessages(response.data.data);
        }
      }
    } catch (error) {
      console.error("Error sending message:", error);

    } finally {
      setButtonLoading((prev) => ({ ...prev, acceptId: null }));
    }
    setMessage("");
    setUploadedFile(null);
    setRejected(false);
  };
  const displayButtons = (data) => {
    const displayPendingMessages = messages.find((x) => x._id === data._id)
    if (displayPendingMessages) {
      return displayPendingMessages.verificationStatus
    } else {
      return '-'
    }
  }
  useEffect(() => {
    const isAccepted = messages.some(msg => msg?.text === '🎉🎊 Congratulations! Sale Deed Draft Accepted Successfully 🎉🎊');
    setvalueData(isAccepted);
  }, [messages]);

  const hasSentSaleDeedRequest = messages?.some(
    (m) => m?.text === SALE_DEED_REQUEST_TEXT
  );
  // eslint-disable-next-line no-unused-vars
  const hasSentRegistrationRequest = messages?.some(
    (m) => m?.text === REGISTRATION_REQUEST_TEXT
  );

  const DocumentPreview = ({
    url,
    title = "Document Preview",
    className = "file-preview",
    height,
    style,
  }) => {
    const [viewerIndex, setViewerIndex] = useState(0);
    const [isFailed, setIsFailed] = useState(false);

    if (!url || typeof url !== "string") {
      return <p className="text-muted">Invalid document URL</p>;
    }

    const cleanUrl = url.split("?")[0].toLowerCase();
    const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(cleanUrl);
    const isPdf = /\.pdf$/.test(cleanUrl);
    const isOfficeDoc = /\.(doc|docx|xls|xlsx|ppt|pptx)$/.test(cleanUrl);

    const officeViewer = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
    const gViewer = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url)}`;

    const sources = isImage
      ? [url]
      : isPdf
        ? [url, gViewer]
        : isOfficeDoc
          ? [officeViewer, gViewer, url]
          : [gViewer, url];

    const previewStyle = height ? { ...style, height } : style;

    const handleLoadError = () => {
      if (viewerIndex < sources.length - 1) {
        setViewerIndex((prev) => prev + 1);
      } else {
        setIsFailed(true);
      }
    };

    if (isFailed) {
      return (
        <div className="doc-preview-fallback">
          <p>Preview unavailable</p>
          <a href={url} target="_blank" rel="noreferrer" className="doc-preview-link">
            Open Document
          </a>
        </div>
      );
    }

    if (isImage) {
      return (
        <img
          src={url}
          alt={title}
          className={className}
          style={previewStyle}
          onError={handleLoadError}
        />
      );
    }

    return (
      <iframe
        src={sources[viewerIndex]}
        className={className}
        height={height}
        style={previewStyle}
        title={title}
        onError={handleLoadError}
      />
    );
  };

  return (
    <div className="property-chat-container responsive-wrapper">
      {/* Chat List (Left Sidebar) */}
      <div className={`property-chat-list ${isMobile && !ShowPropertyList ? 'mobile-hidden' : ''}`}>
        <div className="property-chat-list-header">
          <div className="d-flex align-items-center gap-2">
            <h2>Properties</h2>
            <span className="property-count-badge">{filteredProperties.length}</span>
          </div>
          {isMobile && ShowPropertyList && (
            <span className="close-icon" onClick={() => setShowPropertyList(false)}>
              ×
            </span>
          )}
        </div>
        <div className="property-chat-items">
          <div className="property-search-container">
            <div className="property-search-wrapper">
              <Search size={16} className="search-icon" />
              <input
                type='search'
                className='searchForProperty'
                value={searchTerm}
                onChange={handleSearch}
                placeholder='Search by address or pincode...'
              />
              {searchTerm && (
                <button type="button" className="clear-search-btn" onClick={() => handleSearch({ target: { value: "" } })}>
                  <X size={14} />
                </button>
              )}
            </div>
          </div>
          {filteredProperties.length > 0 ? filteredProperties.map((message) => {
            const isSelected = message._id === selectedUser?._id;
            const remainingDays = getRemainingDays(message);
            const isExpired = message?.saleDeedSubmissionDate &&
              message?.assignedCivilEngineer &&
              message?.saleDeedUploaded === "" &&
              remainingDays === 0;
            const isWarning = message?.saleDeedSubmissionDate &&
              message?.assignedCivilEngineer &&
              message?.saleDeedUploaded === "" &&
              remainingDays > 0;

            return (
              <div
                key={message._id || message.id}
                onClick={() => handleOnClickUser(message)}
                className={`property-chat-item ${isSelected ? 'property-chat-item--active' : ''}`}
              >
                <div className={`property-chat-avatar ${message?.FinalMarketValue !== "" ? 'avatar-success' : ''}`}>
                  <MapPinHouseIcon size={20} />
                </div>
                <div className="property-chat-info">
                  <div className="property-chat-header-row">
                    <span className="property-chat-address" title={message.address}>
                      {message.address}
                    </span>
                    <span className="property-chat-message-pincode">{message.pincode}</span>
                  </div>
                  {isWarning && (
                    <div className="status-pill status-pill--warning">
                      <Clock size={12} /> {remainingDays} {remainingDays === 1 ? 'day' : 'days'} left for Sale Deed
                    </div>
                  )}
                  {isExpired && (
                    <div className="status-pill status-pill--expired">
                      <AlertCircle size={12} /> Sale Deed Expired
                    </div>
                  )}
                </div>
                <div className="property-chat-meta">
                  {message.messageCount > 0 && (
                    <div className='messageCount'>
                      {message.messageCount}
                    </div>
                  )}
                </div>
              </div>
            );
          }) : (
            <div className="property-list-empty">
              <Search size={28} className="text-muted mb-2" />
              <p className="mb-0 text-muted small">No properties found matching your search</p>
            </div>
          )}
        </div>
      </div>

      {/* Main Chat Area (Center Panel) */}
      <div className={`property-chat-main ${isMobile && ShowPropertyList ? 'mobile-hidden' : ''}`}>
        <div className="property-chat-header">
          <div className="property-chat-header-info">
            {isMobile && (
              <>
                {!ShowPropertyList && (
                  <button
                    onClick={showPropertyListView}
                    className="mobile-menu-trigger"
                    aria-label="Open properties menu"
                  >
                    <Menu size={18} />
                    <span>Properties</span>
                  </button>
                )}

                {selectedUser && (
                  <button
                    className="mobile-back-btn"
                    onClick={showPropertyListView}
                    aria-label="Back to properties"
                  >
                    <ArrowLeft size={20} />
                  </button>
                )}
              </>
            )}

            {selectedUser ? (
              <div className="property-chat-header-details">
                <div className="property-chat-header-avatar">
                  <img
                    src={getUserImage(selectedUser)}
                    alt="Avatar"
                    onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_DUMMY_AVATAR; }}
                  />
                </div>
                <div>
                  <h3 className='property-details-title'>
                    <span>Pincode: {selectedUser?.pincode}</span>
                  </h3>
                  <span className='property-details-address'>{selectedUser?.address}</span>
                </div>
              </div>
            ) : (
              <div className="property-chat-header-placeholder">
                <Building2 size={20} className="text-teal" />
                <span className="fw-semibold">Civil Engineer Workspace</span>
              </div>
            )}
          </div>
          {selectedUser && (
            <div className="property-header-actions d-flex align-items-center gap-2">
              <button
                className="header-pencil-btn"
                onClick={() => handleEditIconClick(selectedUser)}
                title="Property Full Details"
                aria-label="View property details"
              >
                <Pencil size={18} />
              </button>
              <button
                className={`panel-side-toggle-btn ${ShowRightPanel ? 'open' : 'closed'}`}
                onClick={() => setShowRightPanel((prev) => !prev)}
                title={ShowRightPanel ? "Close status panel" : "Open status panel"}
                aria-label="Toggle status panel"
              >
                {ShowRightPanel ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
              </button>
            </div>
          )}
        </div>

        <div className="property-chat-messages">
          {!selectedUser ? (
            <div className="chat-empty-state">
              <div className="empty-state-illustration">
                <Building2 size={48} />
              </div>
              <h4>No Property Selected</h4>
              <p>Select an assigned property from the left list to view conversation history, documents, and submit verification updates.</p>
            </div>
          ) : (
            <div className="chat-body">
              {loading ? (
                <div className="loader-container222">
                  <p className="animated-fetch">Fetching property details<span className="dots"></span></p>
                </div>
              ) : BlockChat === selectedUser?.assignedCivilEngineer ? (
                <div className="chat-empty-state">
                  <div className="empty-state-illustration text-danger">
                    <AlertCircle size={48} />
                  </div>
                  <h4>Chat Blocked</h4>
                  <p>Communication for this property is currently restricted.</p>
                </div>
              ) : (
                <div className="chat-messages">
                  {messages.length > 0 ? (
                    <>
                      {messages.length > 1 || messages[0]?.text !== "Hi Engineer, I have uploaded all the documents. Can you help me with the further process?" ? (
                        messages
                          .filter(
                            (msg) =>
                              msg.text !==
                              "Hi Engineer, I have uploaded all the documents. Can you help me with the further process?"
                          )
                          .map((msg, index) => {
                            const extractId = (val) => {
                              if (!val) return "";
                              if (typeof val === "string") return val.trim();
                              if (typeof val === "object") return (val._id || val.userId || val.user_id || val.civilEng_id || val.id || "").trim();
                              return String(val).trim();
                            };

                            const msgSenderId = extractId(msg.senderId || msg.sender);
                            const loggedInEngId = extractId(userDetails?.civilEng_id || userDetails?._id || userDetails?.id);
                            const assignedEngId = extractId(selectedUser?.assignedCivilEngineer);
                            const propUserId = extractId(selectedUser?.userId || selectedUser?.user_id);
                            const propId = extractId(selectedUser?._id);

                            let isCivilEngineer = false;
                            if (msgSenderId) {
                              if (msgSenderId === loggedInEngId || (assignedEngId && msgSenderId === assignedEngId)) {
                                isCivilEngineer = true;
                              } else if (msgSenderId === propUserId || msgSenderId === propId) {
                                isCivilEngineer = false;
                              } else {
                                if (msg.rejected || (msg.text && (msg.text.includes("Rejected") || msg.text.includes("Accepted")))) {
                                  isCivilEngineer = true;
                                } else {
                                  isCivilEngineer = true;
                                }
                              }
                            } else {
                              if (msg.rejected || (msg.text && (msg.text.includes("Rejected") || msg.text.includes("Accepted")))) {
                                isCivilEngineer = true;
                              }
                            }

                            const senderData = isCivilEngineer ? (selectedUser?.assignedCivilEngineer || userDetails) : selectedUser;
                            const userImage = getUserImage(senderData);
                            const userName = isCivilEngineer
                              ? (userDetails?.name || getUserName(selectedUser?.assignedCivilEngineer) || 'Civil Engineer')
                              : (selectedUser?.ownerName || selectedUser?.name || getUserName(selectedUser) || 'User');

                            return (
                              <div
                                key={msg._id || index}
                                className={`message-wrapper ${isCivilEngineer ? "message-right" : "message-left"}`}
                              >
                                {/* Avatar */}
                                <img
                                  className="chat-avatar"
                                  src={userImage}
                                  alt="Avatar"
                                  onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_DUMMY_AVATAR; }}
                                />
                                <div className={`chat-bubble ${isCivilEngineer ? "chat-user" : "chat-bot"}`}>
                                  <div className="chat-username">{userName}</div>
                                  {msg?.text && (msg.text.startsWith("http://") || msg.text.startsWith("https://")) ? (
                                    <>
                                      {msg?.fields?.length > 0 ? (
                                        <>
                                          <div className="chat-document-card">
                                            <div>
                                              <h5 className="chat-document-title">📄 Document</h5>
                                              <div className="chat-document-grid">
                                                <div><b>Issued:</b> {msg.fields[0].issuedByName || "N/A"}</div>
                                                <div><b>Designation:</b> {msg.fields[0].issuedByDesignation || "N/A"}</div>
                                                <div><b>Phone:</b> {msg.fields[0].PhoneNumber || "N/A"}</div>
                                                <div><b>Document Writer Name:</b> {msg.fields[0].preparedByName || "N/A"}</div>
                                              </div>
                                              <div className="chat-document-iframe">
                                                <DocumentPreview
                                                  url={msg.text}
                                                  title="Doc View"
                                                  className="chat-iframe"
                                                  style={{ width: '250px', height: '100%' }}
                                                />
                                              </div>
                                            </div>
                                            {displayButtons(msg) === 'Pending' && !(perDocState[msg._id]?.rejected) && (
                                              <div className="chat-action-buttons">
                                                <div className="chat-actions mb-2">
                                                  <button className="btn-accept" onClick={() => handleAccepty(msg)} disabled={buttonLoading.acceptId === msg._id || buttonLoading.rejectSubmit}>
                                                    {buttonLoading.acceptId === msg._id ? 'Accepting...' : 'Accept'}
                                                  </button>
                                                  <button className="btn-reject" onClick={() => handleReject(msg)} disabled={buttonLoading.acceptId === msg._id || buttonLoading.rejectSubmit}>Reject</button>
                                                </div>
                                              </div>
                                            )}

                                            <p className={msg.verificationStatus === 'Accepted' ? 'AccpetTextColor' : msg.verificationStatus === 'Pending' ? 'PendingTextColor' : 'RejectedTextColor'}>{msg.verificationStatus}</p>
                                          </div>
                                          {displayButtons(msg) === 'Pending' && (perDocState[msg._id]?.rejected) && (
                                            <div className="rejection-wrapper">
                                              <input
                                                type="text"
                                                placeholder="Enter reason for rejection"
                                                value={perDocState[msg._id]?.reason || ""}
                                                onChange={(e) => handleReasonChange(msg, e.target.value)}
                                                className="form-control rejection-input"
                                              />
                                              <div className="rejection-actions">
                                                <button className="btn-submit-rejection" onClick={() => submitReason(msg)} disabled={buttonLoading.rejectSubmit}>
                                                  {buttonLoading.rejectSubmit ? 'Submitting...' : 'Submit'}
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </>) : (
                                        <DocumentPreview
                                          url={msg.text}
                                          className="file-preview"
                                          height="60"
                                          title="File Preview"
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {msg?.files?.map((x, i) => (
                                        <DocumentPreview
                                          key={i}
                                          url={x.url}
                                          className="file-preview"
                                          height="60"
                                          title={`Document Viewer ${i}`}
                                        />
                                      ))}
                                      <div className="chat-message-text">
                                        {/(?:\+?\d{1,4}[\s-]?)?(?:\(?\d{2,4}\)?[\s-]?)?\d{3,4}[\s-]?\d{4}/.test(msg.text) ||
                                          /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(msg.text)
                                          ? <i style={{ color: "red" }}>Message hidden (contains restricted info)</i>
                                          : msg.text
                                        }
                                        <span className="chat-time-stamp">
                                          {moment(msg.createdAt).format("LT")}
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>

                            );
                          })
                      ) : (
                        <div className="chat-empty-state">
                          <div className="empty-state-illustration">
                            <MessageSquareOff size={48} />
                          </div>
                          <h4>No Conversation History</h4>
                          <p>No message thread available for this property yet. You can post an update below.</p>
                        </div>
                      )}

                      <div ref={messagesEndRefUser2} />
                    </>
                  ) : (
                    <div className="chat-empty-state">
                      <div className="empty-state-illustration">
                        <MessageSquareOff size={48} />
                      </div>
                      <h4>No Chat Available</h4>
                      <p>There are no messages recorded for this property yet.</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {selectedUser && BlockChat !== selectedUser?.assignedCivilEngineer && (
          <div className="property-chat-input">
            {(() => {
              const requiredDocs = [
                "⁠link documents explaining the title deeds?",
                "⁠Revenue department links?",
                "Advance receipt or any other proof of purchase?",
                "Property ownership details like previous Sale deed registered with seller?",
              ];

              const hasAllDocs = requiredDocs.every((reqType) =>
                UserUploadedDocs?.some(
                  (doc) =>
                    doc.Type?.trim() === reqType && (doc.url || doc.value) !== "No"
                )
              );
              return hasAllDocs && (
                selectedUser.saledeedVerified === false && !hasSentSaleDeedRequest && (
                  <div className="confirmation-banner">
                    <span className="confirmation-text">
                      Do you wish to ask the user to submit the <strong>Sale deed document</strong>?
                    </span>
                    <button
                      className="yesButton"
                      disabled={buttonLoading.saleDeedRequest}
                      onClick={() => handleSendSaledeedRequestToUser('saledeed')}
                    >
                      {buttonLoading.saleDeedRequest ? 'Sending...' : 'Send Request'}
                    </button>
                  </div>
                )
              );
            })()}
            <div className="message-input-box">
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message or update..."
                className="auto-expand"
                rows={1}
              />
              <button
                className="property-chat-send-btn"
                onClick={handleSendMessage}
                disabled={buttonLoading.send || !message.trim()}
                title="Send Message"
              >
                <Send size={16} />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Right Panel (Property Status Information) */}
      <div className={`property-chat-right-panel ${!ShowRightPanel ? 'panel-closed' : 'panel-open'} ${isMobile ? 'mobile-hidden' : ''}`}>
        <div className="property-chat-panel-header">
          <h3>Property Status Information</h3>
          <button className="property-chat-close-btn" onClick={() => setShowRightPanel(false)} aria-label="Close panel">×</button>
        </div>

        {selectedUser ? (
          <>
            <div className="property-chat-group-profile">
              <ProgressWithCategories
                UserUploadedDocs={UserUploadedDocs}
              />
            </div>

            <div className="property-chat-panel-section">
              <div className="property-chat-section-header">
                <h4>Questions Checklist</h4>
                {UserUploadedDocs.length > 3 && (
                  <span className="property-chat-view-all" onClick={toggleShowAllQuestions}>
                    {showAllQuestions ? "View Less" : "View All"}
                  </span>
                )}
              </div>
              <div className="property-chat-members-list">
                <div className="property-chat-files-list">
                  {(showAllQuestions ? UserUploadedDocs : UserUploadedDocs.slice(0, 3)).map((property, index) => (
                    <div className="question-item-card" key={index}>
                      <div className="d-flex align-items-start gap-2">
                        <span
                          className={`status-check-icon ${checkUserUploadedToQuestions(property) ? 'status-check-icon--success' : 'status-check-icon--danger'}`}
                        >
                          {checkUserUploadedToQuestions(property) ? '✓' : '✗'}
                        </span>
                        <div className="flex-grow-1">
                          <p className="question-item-text">
                            {property.Type}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="property-chat-panel-section">
              <div className="property-chat-section-header d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Uploaded Documents</h4>
                {UserUploadedDocs.length > 3 && (
                  <span className="property-chat-view-all" onClick={toggleShowAllFiles}>
                    {showAllFiles ? "View Less" : "View All"}
                  </span>
                )}
              </div>

              <div className="property-chat-files-list">
                {UserUploadedDocs.length > 0 ? (
                  (showAllFiles ? UserUploadedDocs : UserUploadedDocs.slice(0, 3)).map((property, index) => (
                    <div
                      className="file-card"
                      key={index}
                    >
                      <div className="d-flex align-items-start mb-2 me-1">
                        <span
                          className={`status-icon me-2 fs-5 fw-bold ${checkUserUploadedToQuestions(property) ? "text-success" : "text-danger"
                            }`}
                        >
                          {checkUserUploadedToQuestions(property) ? "✓" : "✗"}
                        </span>
                        <div>
                          <p className="mb-1 fw-semibold text-dark">Question Type</p>
                          <p className="mb-0 text-muted small">{property.Type}</p>
                        </div>
                      </div>
                      <div className="document-preview mt-2">
                        {property.url && property.url.startsWith("http") ? (
                          <DocumentPreview
                            url={property.url}
                            className="document-frame"
                            title={`Document Viewer ${index}`}
                            style={{
                              width: '100%',
                              height: '65px',
                              border: 'none',
                              borderRadius: '6px',
                              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
                            }}
                          />
                        ) : (
                          <p className="text-success small mb-0">{property.url}</p>
                        )}
                      </div>
                      {property.history && property.history.length > 0 && (
                        <div className="document-history-container mt-2 pt-2 border-top">
                          <div className="text-muted small fw-semibold mb-1" style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span>🕒 Previous Versions:</span>
                          </div>
                          <div className="d-flex flex-wrap gap-2">
                            {property.history.map((hist, hIdx) => (
                              <a
                                key={hIdx}
                                href={hist.url}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-xs px-2 py-1 text-decoration-none d-inline-flex align-items-center gap-1"
                                style={{
                                  fontSize: '10px',
                                  backgroundColor: '#f1f3f5',
                                  border: '1px solid #dee2e6',
                                  borderRadius: '4px',
                                  color: '#1fb6a6',
                                  fontWeight: '500'
                                }}
                                title={`Status: ${hist.verificationStatus || 'Unknown'}${hist.rejectionReason ? ` - Reason: ${hist.rejectionReason}` : ''}`}
                              >
                                v{hIdx + 1}
                              </a>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-muted small text-center my-3">No uploaded documents found</p>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="panel-empty-state">
            <div className="empty-state-illustration-sm">
              <ShieldCheck size={36} />
            </div>
            <h4>Status Overview</h4>
            <p>Select a property to view overall verification progress, question checklist, and submitted documents.</p>
          </div>
        )}
      </div>

      <EditPropertyModal
        showEditModal={showEditModal}
        setShowEditModal={setShowEditModal}
        PropertyDetails={PropertyDetails}
        page222={page}
      />
    </div>
  );
};

export default RequestedProperties;